module.exports = __webpack_public_path__ + "img/spinner-third-regular.51d9412b.svg";